<template>
  <div>
    <p class="text-lg font-bold">
      {{ t('$.page_not_found') }}
    </p>
  </div>
</template>

<script setup lang="ts"></script>
